import { useContext } from "react";

import { MenuContext } from "../contexts/menu";

export function useMenu() {
  const context = useContext(MenuContext);

  if (!context) {
    throw new Error("useMenu hook must be used inside a menu provider");
  }

  return context;
}
